import * as React from "react";
import type { SVGProps } from "react";
const SvgIntercomIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M12.316 6.745a.55.55 0 0 0-1.1 0v10.498a.55.55 0 1 0 1.1 0zM16.88 6.745a.55.55 0 0 0-1.1 0v10.498a.55.55 0 1 0 1.1 0zM8.208 9.027a.55.55 0 1 0-1.1 0v5.934a.55.55 0 0 0 1.1 0zM20.988 9.027a.55.55 0 0 0-1.1 0v5.934a.55.55 0 0 0 1.1 0z"
    />
    <path
      fill="#858585"
      d="M7.095 17.275a.55.55 0 0 0-.7.849c1.357 1.117 3.73 2.446 6.492 2.836 2.785.392 5.963-.174 8.84-2.858a.55.55 0 1 0-.751-.805c-2.602 2.428-5.433 2.926-7.935 2.573-2.526-.356-4.716-1.582-5.946-2.595"
    />
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M4.55 3A1.55 1.55 0 0 0 3 4.55v18.996c0 .856.694 1.55 1.55 1.55h18.996a1.55 1.55 0 0 0 1.55-1.55V4.55A1.55 1.55 0 0 0 23.546 3zM4.1 4.55a.45.45 0 0 1 .45-.45h18.996a.45.45 0 0 1 .45.45v18.996a.45.45 0 0 1-.45.45H4.55a.45.45 0 0 1-.45-.45z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIntercomIcon;
